import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import VideoDownloader from './components/VideoDownloader';
import VideoGallery from './components/VideoGallery';
import Login from './components/Login';
import AdminDashboard from './components/admin/AdminDashboard';
import AdminUploads from './components/admin/AdminUploads';

const App: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);

  // Controlla lo stato di autenticazione al caricamento della pagina
  useEffect(() => {
    const authStatus = localStorage.getItem('isAuthenticated') === 'true';
    setIsAuthenticated(authStatus);
  }, []);

  // Funzione per gestire il login/logout
  const handleAuthChange = (status: boolean) => {
    setIsAuthenticated(status);
    localStorage.setItem('isAuthenticated', status ? 'true' : 'false');
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<VideoDownloader />} />
        <Route path="/gallery" element={<VideoGallery />} />
        <Route path="/login" element={
          <Login onAuthChange={handleAuthChange} />
        } />
        <Route 
          path="/admin" 
          element={isAuthenticated ? <AdminDashboard onLogout={() => handleAuthChange(false)} /> : <Navigate to="/login" />} 
        />
        <Route path="/admin/uploads" element={<AdminUploads />} />
      </Routes>
    </Router>
  );
};

export default App;